import { useSearchParams } from 'react-router';
import { sv } from '@aldorock-fordon/shared/sv';
import { PublicShell } from '../components/PublicShell.tsx';
import { usePage } from '../page.ts';

const MESSAGES: Record<string, { text: string; state: 'bad' | 'none' }> = {
  'ingen-behorighet': { text: sv.login.noAccess, state: 'bad' },
  fel: { text: sv.login.failed, state: 'bad' },
  nekad: { text: sv.login.denied, state: 'bad' },
  inaktiv: { text: sv.login.expired, state: 'none' },
};

export function LoginPage({ returnTo }: { returnTo?: string }) {
  const [params] = useSearchParams();
  const h1 = usePage(sv.login.title);
  const message = MESSAGES[params.get('status') ?? ''];
  const target = returnTo ?? params.get('return') ?? '/';
  return (
    <PublicShell>
      <div className="narrow">
        <h1 ref={h1} tabIndex={-1}>
          {sv.login.title}
        </h1>
        {message ? (
          <p className="notice" data-state={message.state} role="status">
            {message.text}
          </p>
        ) : null}
        <p>{sv.login.intro}</p>
        <a className="btn btn-primary" href={`/auth/login?return=${encodeURIComponent(target)}`}>
          {sv.login.button}
        </a>
      </div>
    </PublicShell>
  );
}

export function LoggedOutPage() {
  const h1 = usePage(sv.login.loggedOut);
  return (
    <PublicShell>
      <div className="narrow">
        <h1 ref={h1} tabIndex={-1}>
          {sv.login.loggedOut}
        </h1>
        <a className="btn btn-primary" href="/auth/login?return=%2F">
          {sv.login.button}
        </a>
      </div>
    </PublicShell>
  );
}
